import type React from 'react';

import { tailwindMerge } from '../../../../tailwind';

export type ButtonLabelProps = Omit<React.HTMLProps<HTMLSpanElement>, 'color'>;

export const ButtonLabel = ({
  children,
  className,
  ...props
}: ButtonLabelProps) => (
  <span
    className={tailwindMerge(
      'text-s leading-m m-0 inline-block font-semibold tracking-[0.5px] uppercase',
      className,
    )}
    {...props}
  >
    {children}
  </span>
);
